// extracted by mini-css-extract-plugin
export default {"menubar":"MenuBar_menubar__SusMT","item":"MenuBar_item__ZclM1","item_active":"MenuBar_item_active__W9UpF","ani":"MenuBar_ani__ShBVl"};